import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as SuccessIcon } from 'assets/Message_open_error.svg';
import ComplexTranslate from 'components/ComplexTranslate';
import i18nContext from 'components/i18n-context';
import { getErrorMessageForAlert } from 'services/utils';
import Button from 'uikit/Button/Button';
import Alert from 'uikit/Alert/Alert';

export const DeleteUserScheme = ({
  representativeMail,
  closePopUp,
  generateSecurityCode,
  isShowingInternalActionConfirmation,
  temporaryError
}) => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'scheme-wrapper pop-up-success delete'}>
      <SuccessIcon />
      <h2 className={'scheme-success-header'}>{i18n.getMessage('representatives.header.removeRepresentative')}</h2>
      <p className={'scheme-success-message'}>
        <ComplexTranslate
          text={'representatives.removeRepresentative'}
          interpolation={{
            representative: <strong>{representativeMail}</strong>
          }}
        />
      </p>
      {temporaryError && (
        <Alert
          type={'warning'}
          className={'delete-user-temporary-error-alert'}
          message={getErrorMessageForAlert(i18n, temporaryError)}
        />
      )}
      <div className={'scheme-wrapper-buttons'}>
        <Button
          className={'scheme-button'}
          size={'large'}
          type={'outline'}
          onClick={generateSecurityCode}
          isDisabled={isShowingInternalActionConfirmation}
        >
          {i18n.getMessage('representatives.text.yes')}
        </Button>
        <Button className={'scheme-error-button scheme-button'} size={'large'} onClick={closePopUp}>
          {i18n.getMessage('representatives.text.no')}
        </Button>
      </div>
    </div>
  );
};

DeleteUserScheme.propTypes = {
  representativeMail: PropTypes.string,
  handleRemoveClick: PropTypes.func,
  closePopUp: PropTypes.func.isRequired,
  error: PropTypes.object,
  clearError: PropTypes.func,
  generateSecurityCode: PropTypes.func,
  isShowingInternalActionConfirmation: PropTypes.bool,
  temporaryError: PropTypes.object
};
